import { useEffect } from 'react';

/**
 * Carga el script de Google AdSense condicionalmente.
 * - Si enable es true y el script no está presente, lo inserta.
 * - No lo remueve al deshabilitar para evitar parpadeos en navegación; para páginas sensibles, use sanidad local.
 */
export default function AdSenseLoader({ enable, client = 'ca-pub-3644314222220794' }) {
  useEffect(() => {
    if (!enable) return;
    const SRC = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;

    const existing = Array.from(document.getElementsByTagName('script'))
      .find(s => s.src && s.src.startsWith('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'));

    if (existing) return;

    const script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = SRC;
    document.head.appendChild(script);

    return () => {
      // No removemos el script para no romper anuncios en navegación; el saneo se hace por página.
    };
  }, [enable, client]);

  return null;
}

